export default __webpack_public_path__ + "static/logo-primary-3fc56174b665d088620184c432a4ccab.gif";